/**
 * Labels API
 */

import type { Label } from '../types';
import { fetchApi } from './fetch';

export async function getLabels(): Promise<Label[]> {
  const data = await fetchApi<{ data: Label[]; total: number; limit: number; skip: number }>('/labels');
  return data.data;
}
